import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  breakpoint: null,
  viewportHeight: typeof window !== 'undefined' ? window.innerHeight : null,
}

const windowObserver = createSlice({
  name: 'windowObserver',
  initialState,
  reducers: {
    updateBreakpoint: (state, action) => {
      state.breakpoint = action.payload;
    },
    updateViewportHeight: (state, action) => {
      state.viewportHeight = action.payload;
    },
  },
})

export const { updateBreakpoint, updateViewportHeight } = windowObserver.actions

export default windowObserver.reducer
